<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/quoting/shared/quote-widget/quote-widget.component.ts
-->
<ng-template #anchor></ng-template>
